"use strict";
exports.__esModule = true;
exports.chart_color_red_100 = {
  "name": "--pf-v5-chart-color-red-100",
  "value": "#c9190b",
  "var": "var(--pf-v5-chart-color-red-100, #c9190b)"
};
exports["default"] = exports.chart_color_red_100;